import type { Review, ReviewerRelationship } from '../types/content';

/** Only approved, complete reviews — ordered by rank, capped at five. */
export function getPublishedReviews(list: Review[], count = 5): Review[] {
  return list
    .filter((r) => r.status === 'approved' && r.quote.trim() && (r.anonymous || r.name.trim()))
    .sort((a, b) => a.rank - b.rank)
    .slice(0, count);
}

export function getAttribution(review: Review): { name: string; title?: string } {
  if (review.anonymous) {
    return { name: review.anonymousDescriptor ?? review.title };
  }
  const title = [review.title, review.company].filter(Boolean).join(', ');
  return { name: review.name, title: title || undefined };
}

const VERIFIED_LABELS: Record<ReviewerRelationship, string> = {
  Client: 'Verified client',
  Candidate: 'Verified candidate',
  'Business partner': 'Verified partner',
};

export function verifiedLabel(relationship: ReviewerRelationship): string {
  return VERIFIED_LABELS[relationship];
}
